/**
 * Page chrome: header state on scroll, starfield parallax (pointer devices
 * only), and the hover decrypt on nav labels.
 */
import { TextScramble } from '../scramble';

export function initChrome(): void {
  const header = document.querySelector<HTMLElement>('[data-header]');
  const stars = document.querySelector<HTMLElement>('[data-parallax]');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let ticking = false;
  const update = () => {
    ticking = false;
    const y = window.scrollY;
    header?.classList.toggle('is-scrolled', y > 24);
    if (stars && fine && !reduce) {
      stars.style.transform = `translate3d(0, ${(-y * 0.08).toFixed(1)}px, 0)`;
    }
  };
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );
  update();

  if (!fine || reduce) return;

  document.querySelectorAll<HTMLElement>('[data-hover-scramble]').forEach((el) => {
    const original = (el.textContent ?? '').trim();
    const host = el.closest<HTMLElement>('a, button') ?? el;
    const scramble = new TextScramble(el);
    let busy = false;
    host.addEventListener('mouseenter', () => {
      if (busy) return;
      busy = true;
      void scramble.setText(original, 16).then(() => {
        busy = false;
      });
    });
  });
}
